<template>
  <div class="futures-public-trading-disabled-overlay">
    <p class="futures-public-trading-disabled-overlay__message">
      {{ $t('ui.futuresPublicTradingDisabled.message') }}
    </p>
  </div>
</template>

<style lang="scss">
.futures-public-trading-disabled-overlay {
  position: absolute;
  z-index: var(--futures-public-trading-disabled-overlay-z-index);
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgb(var(--v-theme-overlay-2));
  opacity: 1;
  transition: opacity 200ms ease-out;

  &__message {
    padding: 0 10px;
    color: rgb(var(--v-theme-text-primary));
    font-size: var(--font-size-md);
    text-align: center;
  }
}
</style>
